import type { WeeklyPlanExecutionMode } from "../../../shared/weekly-planning";

export function WeeklyPlanningExecutionModeField(props: {
  value: WeeklyPlanExecutionMode;
  disabled: boolean;
  onChange: (value: WeeklyPlanExecutionMode) => void;
}) {
  return (
    <label>
      Çalışma biçimi
      <select
        value={props.value}
        disabled={props.disabled}
        onChange={(event) => props.onChange(event.target.value as WeeklyPlanExecutionMode)}
      >
        <option value="CAPACITY_SCHEDULED">Kapasite ve saat planlı</option>
        <option value="OPERATOR_SELECTED">Operatör iş emri seçer</option>
      </select>
    </label>
  );
}
